<template>
    <div>
        <select-file :value="fileIds" :default-dir-id="defaultDirId" valueType="id" :size="1000"  @change="fileChanged"></select-file>
        <el-button type="danger" @click="batchDelete">批量删除</el-button>
        <el-table
                size="small"
                :data="multipleSelection"
                ref="tableRef"
                stripe
                border
                highlight-current-row
                style="margin-top: 20px"
        >
            <el-table-column align="center" label width="180" type="selection"></el-table-column>
            <el-table-column align="center" label="id" width="140">
                <template slot-scope="scope">
                    <span>{{scope.row.id}}</span>
                </template>
            </el-table-column>
            <el-table-column width="270" align="center" label="文件名称">
                <template slot-scope="scope">
                    <span>{{scope.row.name}}</span>
                </template>
            </el-table-column>
            <el-table-column width="120" align="center" label="文件作者">
                <template slot-scope="scope">
                    <span>{{scope.row.author}}</span>
                </template>
            </el-table-column>
           <el-table-column width="120" align="center" label="文件类型">
                  <template slot-scope="scope">
                      <span v-if="scope.row.type === 0">
                          <el-tag type="success">文本</el-tag>
                      </span>
                      <span v-else-if="scope.row.type === 1">
                          <el-tag type="warning">音频</el-tag>
                      </span>
                      <span v-else-if="scope.row.type === 2">
                          <el-tag type="info">图片</el-tag>
                      </span>
                      <span v-else-if="scope.row.type === 3">
                          <el-tag type="danger">视频</el-tag>
                      </span>
                      <span v-else-if="scope.row.type === 6">
                          <el-tag type="danger">文件</el-tag>
                      </span>
                  </template>
              </el-table-column>
            <el-table-column width="600" align="center" label="文件内容">
                <template slot-scope="scope">
                    <el-link :href="scope.row.content" target="_blank">{{scope.row.content.length > 40?scope.row.content.split(100) + "...": scope.row.content}}</el-link>
                </template>
            </el-table-column>
            <el-table-column width="200" align="center" label="创建时间">
                <template slot-scope="scope">
                    <span>{{scope.row.createTime || '无'}}</span>
                </template>
            </el-table-column>
        </el-table>
    </div>

</template>
<script>
import { mapGetters } from 'vuex'
import { getUser } from '@/api/demo/user'
import selectFile from '@/components/file/selectFile.vue'
import UserInfo from '@/components/users/userInfo.vue'
import { fileResourceList } from '@/api/demo/file'
export default {
  name: 'selectFileList',
  computed: {
    ...mapGetters(['elements'])
  },
  components: {
    UserInfo,
    selectFile
  },
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    defaultDirId: {
      type: String,
      default: '0'
    }
  },
  watch: {

    value: {
      handler: function (val, oldVal) {
        console.log('watch', val)
        this.fileIds = [...val]
        this.getSearch()
      },
      deep: true
    }
  },
  data () {
    return {
      fileIds: [], // 用户id
      multipleSelection: [], // 用户数据
      dlUserShow: false,
      dialogUserList: [], // 弹窗用户列表
      listLoading: false
    }
  },
  created () {
    let that = this
  },
  mounted () {
    this.fileIds = [...this.value]
    this.getSearch()
  },

  methods: {

    fileChanged (val) {
      this.fileIds = [...val]
      this.updateList()
      this.getSearch()
    },
    // 获取用户列表
    async getSearch () {
      if (this.fileIds.length === 0) {
        this.multipleSelection = []
        return
      }
      let that = this
      that.listLoading = true
      let params = {
        page: 1,
        size: 1000,
        ids: this.fileIds
      }
      let res = await fileResourceList(params)
      that.listLoading = false
      console.log('getFiles', res)
      that.multipleSelection = res.records
    },
    // 清空
    cancel (form) {
      this.$refs[form].resetFields()
    },
    // 选择用户
    getCommodity () {
      this.dlUserShow = true
      this.dialogUserList = this.multipleSelection // 勾选回选
    },
    // 删除用户
    removeUserList (row, index) {
      let that = this
      // 删除fileIds
      this.deleteId(row.id)
      this.updateList()
    },
    updateList () {
      this.$emit('update:value', this.fileIds)
    },
    // 批量删除
    async batchDelete () {
      let that = this
      if (!that.$refs.tableRef.selection.length) {
        that.$message.error('请勾选要删除的用户')
        return
      }
      // 已选择的文件
      var seid = that.$refs.tableRef.selection
      for (let i = 0; i < seid.length; i++) {
        // 删除fileIds
        this.deleteId(seid[i].id)
      }
      that.updateList()
    },
    // 删除指定id
    deleteId (id) {
      let that = this
      // 删除fileIds
      let index = that.fileIds.indexOf(id)
      if (index > -1) {
        that.fileIds.splice(index, 1)
      }
    },
    // 有效时间
    dataSearch (e) {
      this.form.giftFailureTime = e
    }
  }
}
</script>
<style scope>
.dialog-footer {
    display: flex;
    justify-content: center;
    align-items: center;
}
.margins {
    margin-bottom: 30px !important;
}
</style>
